import { render, staticRenderFns } from "./ActivitySidebarItem.vue?vue&type=template&id=93d1b154&lang=html&"
import script from "./ActivitySidebarItem.vue?vue&type=script&lang=js&"
export * from "./ActivitySidebarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports